import React from 'react';
import { auth } from '../firebase';
import { signOut } from 'firebase/auth';
import { useNavigate } from 'react-router-dom';

function PendingApproval() {
    const navigate = useNavigate();

    const handleLogout = () => {
        signOut(auth);
        navigate('/login');
    };

    return (
        <div className="flex-container center-content">
            <div className="glass-card pending-card">
                <div className="pending-icon">⏳</div>
                <h2>Хүлээгдэж байна</h2>
                <p className="subtitle">
                    Таны бүртгэлийг админ баталгаажуулсны дараа та системд нэвтрэх боломжтой болно.
                    Түр хүлээнэ үү.
                </p>
                <button className="btn btn-secondary mt-3" onClick={handleLogout}>
                    ← Гарах
                </button>
            </div>
        </div>
    );
}

export default PendingApproval;
